import { RefObject } from "react"
import { MuxVideo, MuxVideoTokenResponse } from "@/schema"
import MuxPlayer from "@mux/mux-player-react"
import { cn } from "@ui/utils"

export default function MuxVideoPlayer({
  muxVideo,
  tokens,
  isPublic,
  onTimeUpdate,
  videoRef,
  className,
}: {
  muxVideo?: MuxVideo
  tokens?: MuxVideoTokenResponse
  isPublic: boolean
  onTimeUpdate?: (event: Event) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  videoRef?: RefObject<any>
  className?: string
}) {
  if (isPublic)
    return (
      <div className="aspect-video w-full">
        <MuxPlayer
          className={cn("h-full w-full", className)}
          playbackId={muxVideo?.playback_id ?? undefined}
          tokens={undefined}
          onTimeUpdate={onTimeUpdate}
          ref={videoRef}
          style={{ "--captions-button": "none" } as React.CSSProperties}
          accentColor="#6366F1"
          defaultHiddenCaptions={true}
        />
      </div>
    )

  if (!isPublic && !!tokens?.video_token)
    return (
      <div className="aspect-video w-full">
        <MuxPlayer
          className={cn("h-full w-full", className)}
          playbackId={muxVideo?.playback_id ?? undefined}
          tokens={{ playback: tokens?.video_token, thumbnail: tokens?.thumbnail_token ?? undefined }}
          onTimeUpdate={onTimeUpdate}
          ref={videoRef}
          style={{ "--captions-button": "none" } as React.CSSProperties}
          accentColor="#6366F1"
          defaultHiddenCaptions={true}
        />
      </div>
    )
}
